/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_EntityInputs */

const cs_gdpr_audit_entity = /** @type {(inputs: Gdpr_Audit_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ záznamu`)
};

const en_gdpr_audit_entity = /** @type {(inputs: Gdpr_Audit_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record type`)
};

/**
* | output |
* | --- |
* | "Record type" |
*
* @param {Gdpr_Audit_EntityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_entity = /** @type {((inputs?: Gdpr_Audit_EntityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_EntityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_entity(inputs)
	return cs_gdpr_audit_entity(inputs)
});